import { Checkbox, Flex, Form, FormInstance, Radio } from 'antd';
import styles from '../index.module.scss';
import SelectTip from '../../../../../Common/SelectTip';
import { Question } from '../../../../../../hooks/api/questions';

interface SurveyStep1Props {
  form: FormInstance;
  stepCount: number;
  stepCurrent: number;
  question: Question;
}

const SurveyStep = ({
  form,
  stepCount,
  stepCurrent,
  question,
}: SurveyStep1Props) => (
  <div className={styles.content}>
    <div className={styles.stepCount}>{`${stepCurrent + 1}/${stepCount}`}</div>
    <p className={styles.question}>{question.name}</p>
    <Flex justify="center" style={{ width: '100%' }}>
      {(() => {
        switch (question.type) {
          case 'yes/no':
            return (
              <Form.Item
                key={question.id}
                name={question.id}
                rules={[{ required: true, message: 'Обовʼязково' }]}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Radio.Group>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            );
          case 'scale':
            return (
              <div
                style={{
                  maxWidth: 'calc(100% - 72px - 72px)',
                  width: '100%',
                }}
              >
                <SelectTip
                  form={form}
                  nameValue={question.id}
                  nameType={`${question.id}-type`}
                />
              </div>
            );
          case 'single choice':
            return (
              <Form.Item
                key={question.id}
                name={question.id}
                rules={[{ required: true, message: 'Обовʼязково' }]}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Radio.Group options={question.singleChoiceList} />
              </Form.Item>
            );
          case 'multiple choice':
            return (
              <Form.Item
                key={question.id}
                name={question.id}
                rules={[{ required: true, message: 'Обовʼязково' }]}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Checkbox.Group
                  options={question.multipleChoiceList}
                  style={{ flexDirection: 'column' }}
                />
              </Form.Item>
            );
        }
      })()}
    </Flex>
  </div>
);

export default SurveyStep;
